module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud_m.20dde22db6c29fbd6e26527c5e7c2d7b.svg";